import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Image from '../Image'
import './styles/GraduateCard.css';

class GraduateCard extends Component {
    render() {
        const graduate = this.props.graduate;

        const img = graduate.image.thumb ? graduate.image.thumb : graduate.image.placeholder;

        return (
            <Link className={'card-graduate'} to={
                {
                    pathname: `/graduates/${graduate.unikey}`,
                    state: {modal: true}
                }
            }>
                <Image src={img} aspectRatio={'4:3'} cover shadow/>

                <div className='card-graduate__body'>
                    <div className={'sub-category sub-category--small text--pink uppercase'}>
                        {graduate.roles[0] ? graduate.roles.join(' | ') : ''}
                    </div>
                    <div className={'title'}>
                        {graduate.fullName}
                    </div>
                    <div className={'fineprint fineprint--grey'}>
                        {graduate.degree}
                    </div>
                </div>
            </Link>
        );
    }
}

export default GraduateCard;